<script lang="ts">
  import { onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import type { WinCbs, WinProps } from "../scripts/WinTypes";
  import { addLog } from "../stores/LoggerStore";
  export let winProps: WinProps;
  import Loading from "../components/Loading.svelte";
  import { JamBread, JamUser } from "../stores/Router";
  import ProcMgr from "../stores/ProcMgr";
  import { FileMgr } from "../stores/FileMgr";
  import axios from "axios";
  import serverurl from "../scripts/ServerUrl";

  const filemgr = FileMgr.getInstance();
  const procmgr = ProcMgr.getInstance();
  winProps.name = winProps.name || "Hub";
  let home = filemgr.home;
  let windowSetter, canvasElem: HTMLCanvasElement;
  let callbacks: WinCbs = {
    onMount: (setter: (string, any) => void) => {
      addLog("JamHub on mount");
      // setter("maximizeOnMount", true);
      // windowSetter = setter;
      return true;
    },
  };

  let load_ul = false,
    load_ur = false,
    load_dl = false,
    load_dr = false;

  const _str = () => {
    const data = {
      files: filemgr.stringify(),
      proc: procmgr.stringify(),
    };
    console.log(data);
  };

  onMount(() => {});

  const loadInst = async () => {};
  let procs: string[] = [];
  let loadProc = () => {
    let str = procmgr.stringify();
    console.log("ProcMgr str : ", str);
    procmgr.loadFromString(str);
  };
  let loadFile = () => {
    let str = filemgr.stringify();
    console.log("FileMgr str : ", str);
    filemgr.loadFromString(str);
  };
  const validator = (val) => {
    if (!val) return "<not defined>";
    return val.trim().replace(" ", "_");
  };
  let texts = [];
  let breadValue;
  let results = [];
  const log = (_) => {
    results = [_, ...results];
  };

  const onError = (err) => {
    log(`Status[${err.response.status}] Err : ${err}`);
  };

  let user = JamUser,
    bread = JamBread;

  const signup = async (e) => {
    load_dl = true;
    const formData = new FormData(e.target);

    const data = {};
    for (let field of formData) {
      const [key, value] = field;
      data[key] = value;
    }

    const signupRes = await JamUser.signup(data["user"], data["pass"], onError);
    if (!signupRes) {
      log("Something went wrong creating user : " + user);
      load_dl = false;
      return;
    }

    user = await JamUser.login(data["user"], data["pass"], (err) =>
      console.error(err)
    );
    if (user.isEmpty) {
      log(`Log in failed for user : ${data["user"]}`);
      load_dl = false;
      return;
    }
    log(`User id : ${user.getId} logged in`);
    getList();
    load_dl = false;
  };

  const onLogin = async (e) => {
    load_dl = true;
    const formData = new FormData(e.target);

    const data = {};
    for (let field of formData) {
      const [key, value] = field;
      data[key] = value;
    }

    user = await JamUser.login(data["user"], data["pass"], onError);
    if (user.isEmpty) {
      log(`Log in failed for user : ${data["user"]}`);
    } else {
      log(`User id : ${user.getId} logged in`);
      getList();
    }
    load_dl = false;
  };

  const getList = async () => {
    if (user.isEmpty) {
      log("Not logged in");
      return;
    }
    load_dl = true;
    const res = await bread.list();
    console.log("Get list res : ", res);
    breads = [...res];
    load_dl = false;
  };
  const logout = (e) => {
    log(`User ${user.getId} logged out`);
    user.logout();
  };
  // const createBread = async (e) => {
  //   if (user.isEmpty) {
  //     log("Not logged in");
  //     return;
  //   }
  //   const res = await bread.new("qw");
  //   console.log("Suc : ", res?.data?.message);
  // };
  const loadData = async (e) => {
    if (user.isEmpty) {
      log("Not logged in");
      return;
    }
    const res = await bread.load(breadValue);
    if (res) {
      filemgr.loadFromString(res.files);
      procmgr.loadFromString(res.proc);
    }
    console.log(res);
    console.log("Suc : ", res?.data?.message);
  };
  const saveData = async (e) => {
    if (user.isEmpty) {
      log("Not logged in");
      return;
    }
    const res = await bread.save(
      breadValue,
      filemgr.stringify(),
      procmgr.stringify()
    );
    console.log(res);
    if (res) {
      console.log("Response msg : ", res.message);
    }
  };

  let loginMode = true;
  let inputPwValue, inputIdValue;
  const loadBread = async (breadId) => {
    await JamBread.load(breadId);
  };
  let breads = [];
  let alert = "adf";
  let saveBid = "";
  const saveThis = async () => {
    if (saveBid.length === 0) {
      alert = "빵 이름을 입력해주세요.";
      return;
    }
    await JamBread.save(saveBid, filemgr.stringify(), procmgr.stringify());
  };
</script>

<!-- 
  <form on:submit|preventDefault={login}>
          <label for="user">Username:</label><input
            name="user"
            placeholder="아이디"
          /><br />
          <label for="pass">Password:</label><input
            name="pass"
            type="password"
            placeholder="비밀번호"
          /><br />
          <input type="submit" value="로그인하기" />
        </form>
 -->

<Window {winProps} {callbacks}>
  <div class="container">
    <div class="bg-container">
      <img src="/imgs/wall.jpg" alt="" class="bg-img" />
    </div>
    <div class="alert">{alert}</div>
    <div class="content-container">
      <div class="circle-container">
        <h1 class="title">JamHub</h1>
      </div>
      <div class="form-container">
        {#if user.isEmpty}
          <button
            on:click={() => {
              loginMode = true;
            }}>로그인</button
          ><button
            on:click={() => {
              loginMode = false;
            }}>회원가입</button
          >
          {#if loginMode}
            <form on:submit|preventDefault={onLogin}>
              <label for="user">Username:</label><input
                name="user"
                placeholder="아이디"
                bind:value={inputIdValue}
              /><br />
              <label for="pass">Password:</label><input
                name="pass"
                type="password"
                placeholder="비밀번호"
                bind:value={inputPwValue}
              /><br />
              <input type="submit" value="로그인하기" />
            </form>
          {:else}
            <form on:submit|preventDefault={signup}>
              <label for="user">Username:</label><input
                name="user"
                placeholder="아이디"
                bind:value={inputIdValue}
              /><br />
              <label for="pass">Password:</label><input
                name="pass"
                type="password"
                placeholder="비밀번호"
                bind:value={inputPwValue}
              /><br />
              <input type="submit" value="회원가입" />
            </form>
          {/if}
        {:else}
          <div class="breads">
            <div class="save-container">
              <button class="save-this" on:click={saveThis}>Save this</button>
              <textarea
                class="save-bid"
                bind:value={saveBid}
                placeholder="빵 이름을 입력해주세요"
              />
            </div>
            <div class="select-bread">
              {#each breads as bread}
                <button
                  class="bread-btn"
                  on:click={() => {
                    loadBread(bread);
                  }}>{bread}</button
                >
              {/each}
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</Window>

<style>
  .alert {
    width: 100%;
    color: red;
    text-align: center;
  }
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .bg-container {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background-color: #333;
  }
  .title {
    margin: 0;
    padding: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #333;
    font-size: 3rem;
  }
  .content-container {
    position: absolute;
    width: 100%;
    height: 80%;
    left: 0px;
    bottom: 0%;
  }
  .circle-container {
    position: absolute;
    width: 100%;
    height: 62%;
    left: 0px;
    top: 0%;
    border-top-left-radius: 100%;
    background-color: #dbdbdb;
  }
  .form-container {
    position: absolute;
    width: 100%;
    height: 38%;
    left: 0px;
    bottom: 0px;
    background-color: #dbdbdb;
    color: #333;
  }
</style>
